export interface WriterProfileData {
  formats: string[];
  genres: string[];
  influences: string[];
  favoriteBooks: string[];
  styleTraits: Record<string, string>;
  voiceDescription: string;
  writingSample: string;
  goal: string;
  experienceLevel: string;
}

/** Row shape returned by GET /users/writer-profile (text fields are null when unset). */
export interface WriterProfileResponse {
  id?: string;
  formats?: string[];
  genres?: string[];
  influences?: string[];
  favoriteBooks?: string[];
  styleTraits?: Record<string, string>;
  voiceDescription?: string | null;
  writingSample?: string | null;
  goal?: string | null;
  experienceLevel?: string | null;
  completedAt?: string | null;
}

export const emptyWriterProfile = (): WriterProfileData => ({
  formats: [],
  genres: [],
  influences: [],
  favoriteBooks: [],
  styleTraits: {},
  voiceDescription: '',
  writingSample: '',
  goal: '',
  experienceLevel: '',
});

/** Server rows use null for empty text; the form works with strings. */
export const fromResponse = (r: WriterProfileResponse | null | undefined): WriterProfileData => ({
  ...emptyWriterProfile(),
  formats: r?.formats ?? [],
  genres: r?.genres ?? [],
  influences: r?.influences ?? [],
  favoriteBooks: r?.favoriteBooks ?? [],
  styleTraits: r?.styleTraits ?? {},
  voiceDescription: r?.voiceDescription ?? '',
  writingSample: r?.writingSample ?? '',
  goal: r?.goal ?? '',
  experienceLevel: r?.experienceLevel ?? '',
});
